module.exports = __webpack_public_path__ + "img/table2.6ec00bf4.png";